module.exports = __webpack_public_path__ + "media/img/why-vendor/user-5a9c4a2091338339bb8d2cd58324f4bb.svg";